<template>
  <div class="menu-body-wrapper">
    <div class="menu-item-wrapper" :class="{ landscape: isMobileLandscape }">
      <div class="menu-item" @click.stop="openMenuPopup('History')">
        <img src="@/assets/images/history-icon.webp" alt="" />
        <span class="label">{{ $t('History') }}</span>
      </div>
      <div v-if="withCommission" class="menu-item" @click.stop="openMenuPopup('Statement')">
        <img src="@/assets/images/statement-icon.webp" alt="" />
        <span class="label">{{ $t('Statement') }}</span>
      </div>
      <div class="menu-item" @click.stop="openMenuPopup('Help')">
        <img src="@/assets/images/help-icon.webp" alt="" />
        <span class="label">{{ $t('Help') }}</span>
      </div>
      <div class="menu-item" v-if="config.enableJackpot" @click.stop="openMenuPopup(PopupPage.jackpotHelp)">
        <img src="@/assets/images/jackpot-help-icon.webp" alt="" />
        <span class="label">{{ $t('Jackpot') }}</span>
      </div>
      <div class="menu-item" @click.stop="openMenuPopup('Notification')">
        <img src="@/assets/images/notification-icon.webp" alt="" />
        <span class="label">{{ $t('Notification') }}</span>
      </div>
    </div>

    <div class="game-actions">
      <div class="game-actions__toggles">
        <div class="odds-toggle">
          <ToggleBtn
            :leftTxt="$t('Eu')"
            :rightTxt="$t('My')"
            :value="toggleValue"
            v-if="config.availableOddsType.length > 1"
            @toggle="(e) => toggleOdds(e)"
            class="credit-user-menu-item"
          />
        </div>

        <div class="floating-video-toggle">
          <ToggleBtn
            :rightTxt="$t('float video')"
            :value="isFloatingVideo"
            @toggle="(e) => handleChangeToogleValue(e)"
          />
        </div>
      </div>
      <div v-if="withCommission" @click="logoutCreditUser()" class="logout-user">{{ $t('Logout') }}</div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { isMobile } from 'mobile-device-detect';
import { initMgConnection } from '@/utils/websocket';
import ToggleBtn from '@/components/toggle-btn.vue';
import { PopupPage } from '@/utils/index.model';

export default {
  components: {
    ToggleBtn,
  },
  data: () => {
    return {
      PopupPage,
    };
  },
  computed: {
    ...mapGetters({
      withCommission: 'general/withCommission',
      config: 'general/config',
      oddsType: 'general/oddsType',
      token: 'general/token',
    }),
    isFloatingVideo() {
      return this.config.floatVideo;
    },
    isMobileLandscape() {
      return isMobile && this.$screen.width > this.$screen.height;
    },
    toggleValue() {
      return this.oddsType === 'my';
    },
  },
  methods: {
    ...mapActions('menu', ['updateMenu']),
    ...mapActions('general', ['updateOddsType', 'updateFloatVideo']),
    openMenuPopup(page) {
      this.updateMenu({ activePopupPage: page });
    },
    logoutCreditUser() {
      if (window.parent) {
        window.parent.postMessage('Logout', '*');
      }
    },
    handleChangeToogleValue(val) {
      this.updateFloatVideo(!val);
    },
    toggleOdds(val) {
      const updatedOdds = this.config.availableOddsType[val ? 1 : 0];
      this.updateOddsType(updatedOdds);
      initMgConnection(this.token, updatedOdds);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-body-wrapper {
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;

  .menu-item-wrapper {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: wrap;
    align-content: flex-start;
    gap: 8px;

    .menu-item {
      height: 130px;
      width: calc(50% - 4px);
      border-radius: 8px;
      background-color: #10233a;
      font-size: 14px;
      font-weight: 700;
      line-height: 1.21;
      text-align: center;
      color: #efc87f;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      transition: background-color 0.15s ease;

      &:active {
        background-color: #1a3352;
      }

      .label {
        text-transform: uppercase;
        letter-spacing: 0.02em;
      }

      img {
        width: 56px;
        height: 56px;
        margin-bottom: 12px;
      }
    }

    &.landscape {
      .menu-item {
        height: 110px;
      }
    }
  }

  .game-actions {
    flex-shrink: 0;
    font-size: 14px;
    text-transform: uppercase;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px 4px;
    box-sizing: border-box;
    border-top: 1px solid rgba(106, 145, 167, 0.25);

    &__toggles {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .logout-user {
      font-size: 14px;
      color: #e05c5c;
      opacity: 0.9;
      cursor: pointer;
    }
  }
}
</style>
